import PATHS from "constant/paths";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isAuthenticated } from "utils/authenticated";

const Protected = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!isAuthenticated()) {
      navigate(PATHS.LOGIN);
    }
  }, [navigate]);

  return isAuthenticated() ? <>{children}</> : null;
};

export default Protected;
